const ServiceEndpoints = {
  getSettingOptions: 'setting/GetSettingOptions',
  // Home Page API Endpoint
  getNavigationMenu: 'navigation-menu/getMenu',
  getHomeContent: 'home/getContent',
  postNewsletterEmail: 'newsletter/PostNewsletterEmail',
  GetInstagramToken: 'setting/GetInstagramToken',
  GetInstagramPosts:
    'https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url&access_token=',

  // Setting Listing Page API Endpoint
  getSlugDetail: 'category/getSlugDetail',
  getSettingFilters: 'product/getSettingFilters',
  getSettingFiltersFromURL: 'product/getSettingFiltersFromURL',
  getProductsByCategory: 'product/getProductByCategory',
  getDefaultUrl: 'product/GetDefaultUrl',
  setLinkClick: 'product/SetLinkClick',

  // Diamond API Endpoint
  getDiamondFilters: 'diamond/GetDiamondFilters',
  checkDiamondSoldFlag: 'product/checkDiamondSoldFlag',

  // Detail Page API Endpoint
  getProductDetail: 'product/GetProductDetailBySku',
  getRelatedProducts: 'product/GetRelatedProducts',
  getSecondStepUrl: 'product/GetSecondStepUrl',
  // getProductSizes: 'product_size/GetProductSizeByCountryCategory',
  getProductSizes: 'product_size/GetProductSizeById',

  // Complete Jewel API Endpoint
  getReviewProducts: 'product/GetReviewProducts',

  // User API Endpoint
  registration: 'customers/AddCustomer',
  login: 'customers/ValidateCustomer',
  forgetPassword: 'customers/SendPasswordResetEmail',
  validateResetPasswordLink: 'customers/ValidateResetPasswordLink',
  resetPassword: 'customers/ResetPassword',
  updateAccountDetail: 'customers/UpdateAccountDetail',
  changePassword: 'customers/ChangePassword',
  orders: 'Order/GetOrder',
  // DropHint API Endpoint
  sendDropHint: 'newsletter/SendDropHint',

  // WishList API Endpoint
  storeGuestWishlistData: 'product/StoreGuestWishlistData',
  storeWishlistProduct: 'product/StoreWishlistProduct',
  removeWishlistItem: 'product/RemoveWishlistItem',
  removeGuestWishlistData: 'product/RemoveGuestWishlistData',
  getWishListProduct: 'product/GetWishListProduct',
  getWishlistItems: 'product/GetWishlistItems',

  // Cart
  getCartSubtotal: 'cart-checkout/GetCartSubtotal',
  storeGuestCartData: 'cart-checkout/StoreGuestCartData',
  storeCartProducts: 'cart-checkout/StoreCartProducts',
  deleteCartProduct: 'cart-checkout/DeleteCartProduct',
  removeGuestCartData: 'cart-checkout/RemoveGuestCartData',
  getCustomerCartItem: 'cart-checkout/GetCustomerCartItems',
  getStripePaymentIntentSecretKey: 'cart-checkout/GetStripePaymentIntentSecretKey',
  updateStripePaymentIntentSecretKey: 'cart-checkout/UpdateStripePaymentIntentSecretKey',
  getStripeUrl: 'cart-checkout/StripeCheckout',
  placeOrder: 'cart-checkout/CheckoutCartProduct',
  stripeCheckoutSuccess: 'cart-checkout/StripeCheckoutSuccess',
  handlePaypalResponse: 'cart-checkout/HandlePaypalResponse',
  calculateShippingRate: 'cart-checkout/CalculateShippingRate',
  getOrderDetails: 'cart-checkout/GetOrderDetails',
  getCountryList: 'country/getCountryList',
  getShippingMethods: 'cart-checkout/GetShippingMethods',
  setInquiryOrder: 'cart-checkout/SetInquiryOrder',
  CheckSoldDiamondProduct: 'cart-checkout/CheckSoldDiamondProduct',
  // Serch
  GetMainSearchList: 'product/GetMainSearchList',
  // Contact Form
  storeContactForm: 'contact-form/PostContactForm',
  // Blog
  getBlogs: 'blog/getBlogs',
  getBlogBySlug: 'blog/GetBlogBySlug',
  BestsellerCategory: 'category/BestsellerCategory',

  // Productreview
  WriteProductReview: 'product/WriteProductReview',
  GetReviewProducts: 'product/GetReviewProducts',

  // google reviews
  getGoogleReviews: 'home/getGoogleReviews',
  getCountriesStateCities: 'cart-checkout/GetCountriesStateCities',
  generateAuthorizeNetToken: 'cart-checkout/GenerateAuthorizeNetToken',
  processPayment: 'cart-checkout/ProcessPayment',

  // helth check
  ServerhelthCheck: 'helth/CheckHealthStatus',
  GetCountryList: 'country/GetCountryWithCurrency',
  UpdateBuilderFormattedPrice: 'cart-checkout/UpdateBuilderFormattedPrice',
  SetAppointment: 'services/set_appointment',
  UpdateAppointment: 'services/update_appointment',
  GetAppointmentDetail: 'services/get_appointment_detail',
  GetFreeQuoteOptions: 'free-quote/GetFreeQuoteOptions',
  GetDiamondRange: 'free-quote/GetDiamondRange',
  UpdateStripePaymentIntentSecretKey: 'cart-checkout/UpdateStripePaymentIntentSecretKey',
  GetStripePaymentIntentSecretKey: 'cart-checkout/GetStripePaymentIntentSecretKey',
  GetStripeTaxRates: 'cart-checkout/GetStripeTaxRates',
  GetOrderDetails: 'cart-checkout/GetOrderDetails',
  GetPopupDiamondDefaultFilters: 'diamond/GetPopupDiamondFilters',

  // AppointmentQr scan
  Qr_scan_appointment: 'services/qr_scan_appointment'
}
export default ServiceEndpoints
